import ThemeContext from "../context/ThemeContext.js";
import lightTheme from "../theme/themes/light.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeProvider(_ref) {
  let {
    theme = lightTheme,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: theme,
    children: children
  });
}